import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { DefaultFilter } from './default-filter';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'checkbox-filter',
    template: `
    <input type="checkbox" [formControl]="inputControl" [ngClass]="inputClass" class="form-control">
    <a href="#" *ngIf="filterActive"
                (click)="resetFilter($event)">{{column.getFilterConfig()?.resetText || 'reset'}}</a>
  `,
    standalone: false
})
export class CheckboxFilterComponent extends DefaultFilter implements OnInit {

  public filterActive: boolean = false;
  public inputControl: FormControl = new FormControl(false);

  constructor() {
    super();
  }

  public ngOnInit() {
    if (this.inputControl && this.inputControl.valueChanges) {
      this.changesSubscription = this.inputControl.valueChanges
        .pipe(debounceTime(this.delay))
        .subscribe((checked: boolean) => {
          this.filterActive = true;
          const trueVal =
          (this.column.getFilterConfig() && this.column.getFilterConfig().true) || true;
          const falseVal =
          (this.column.getFilterConfig() && this.column.getFilterConfig().false) || false;
          this.query = checked ? trueVal : falseVal;
          this.setFilter();
        });
    }
  }

  public resetFilter(event: any) {
    event.preventDefault();
    this.query = '';
    this.inputControl.setValue(false, { emitEvent: false });
    this.filterActive = false;
    this.setFilter();
  }
}